class ProductOverviewTabs extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    
    this.tabButtons = this.querySelectorAll('.button-tab');
    this.panels = this.querySelectorAll('.product__overview__panel');
    
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.#handleTabClick.bind(this), { signal });
    });
    
    this.#initializeActiveState();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #initializeActiveState() {
    const activeButton = this.querySelector('.button-tab.active');
    
    if (!activeButton && this.tabButtons && this.tabButtons.length > 0) {
      const firstButton = this.tabButtons[0];
      if (firstButton instanceof HTMLElement) {
        this.#switchTab(firstButton);
      }
    } else if (activeButton instanceof HTMLElement) {
      const tabId = activeButton.getAttribute('data-tab');
      const panel = this.querySelector(`#panel-${tabId}`);
      if (panel instanceof HTMLElement && !panel.classList.contains('product__overview__panel--active')) {
        this.#showPanel(panel);
      }
    }
  }

  #handleTabClick(/** @type {Event} */ event) {
    event.preventDefault();
    const button = event.currentTarget;
    
    if (!(button instanceof HTMLElement)) {
      return;
    }
    
    if (button.classList.contains('active')) {
      return;
    }
    
    this.#switchTab(button);
  }

  #switchTab(/** @type {HTMLElement} */ button) {
    const tabId = button.getAttribute('data-tab');
    
    if (!tabId) {
      console.warn('Tab button missing data-tab attribute');
      return;
    }
    
    if (this.tabButtons) {
      this.tabButtons.forEach((btn) => {
        btn.classList.remove('active');
      });
    }
    
    button.classList.add('active');
    
    if (this.panels) {
      this.panels.forEach((panel) => {
        if (panel instanceof HTMLElement) {
          this.#hidePanel(panel);
        }
      });
    }
    
    const panel = this.querySelector(`#panel-${tabId}`);
    if (panel instanceof HTMLElement) {
      this.#showPanel(panel);
    } else {
      console.warn(`Panel with id "panel-${tabId}" not found`);
    }
  }

  #showPanel(/** @type {HTMLElement} */ panel) {
    panel.classList.add('product__overview__panel--active');
    panel.style.display = '';
  }
  
  #hidePanel(/** @type {HTMLElement} */ panel) {
    panel.classList.remove('product__overview__panel--active');
    panel.style.display = 'none';
  }
}

customElements.define('product-overview-tabs', ProductOverviewTabs);

